import { Box, Flex, Input, SimpleGrid, Text } from '@chakra-ui/react';
import Pagination from 'components/Pagination';
import { useScreenWidth } from 'hooks/useScreenWidth';
import { ITEMS_PER_PAGE } from 'utils/utils';

export default function FullPagination({ handlePageClick, fullData }) {
    const screen = useScreenWidth();
    return (
        <Box bg="white" w="full">
            <SimpleGrid columns={{ base: 1, md: 2 }} alignItems="center" pb={{ base: 8, md: 0 }}>
                <Text mx="5" fontSize="sm" color="#919EAB">
                    {fullData?.length} results
                </Text>
                <Flex
                    mx="5"
                    justifyContent={screen > 500 ? 'flex-end' : 'flex-start'}
                    alignItems="center">
                    {screen > 500 && (
                        <Flex mr="10" alignItems="center">
                            <Text mr="5" color="#000" fontSize="sm" fontWeight="500">
                                Show
                            </Text>
                            <Input
                                borderColor="#C9C9C9"
                                type="text"
                                onBlur={(e) => handlePageClick({ selected: e.target.value })}
                                max={fullData?.length}
                                w="10"
                                p="2"
                                h="8"
                            />
                        </Flex>
                    )}
                    <Pagination
                        items={fullData}
                        itemsPerPage={ITEMS_PER_PAGE}
                        handlePageClick={handlePageClick}
                    />
                </Flex>
            </SimpleGrid>
        </Box>
    );
}
